import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconX } from "@tabler/icons-react";
import { LangConstant, KeyConstant } from "const";
import { StorageUtils, SystemUtils } from "utils";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useGetBranchQR } from "hooks";

const CreateQRDialog = ({ open, onClose }) => {
  const { t: getLabel } = useTranslation();
  const { getBranchQR } = useGetBranchQR();

  const [currentBranchExpiryTime, setCurrentBranchExpiryTime] = useState(
    StorageUtils.getStoreData(KeyConstant.KEY_BRANCH_QR_EXPIRY_TIME),
  );
  const [time, setTime] = useState(null);
  const [dataQR, setDataQR] = useState(null);
  const [isOpenConfirmClose, setIsOpenConfirmClose] = useState(false);

  const handleSubmit = async () => {
    if (time) {
      if (time.getTime() < Date.now()) {
        SystemUtils.appendNotification("Thời hạn QR không hợp lệ", "error");
        return;
      }
      SystemUtils.openCircleLoading();
      const qr = await getBranchQR({ qr_expiry_time: time.getTime() });
      if (qr) {
        SystemUtils.appendNotification("Tạo mã QR thành công", "success");
        StorageUtils.storeData(KeyConstant.KEY_BRANCH_QR_EXPIRY_TIME, time.getTime());
        setCurrentBranchExpiryTime(time.getTime());
      }
      setDataQR(qr);
      SystemUtils.openCircleLoading(false);
    }
  };

  const handleClose = () => {
    setIsOpenConfirmClose(false);
    onClose();
  };

  useEffect(() => {
    if (currentBranchExpiryTime) {
      if (currentBranchExpiryTime <= Date.now()) {
        const today = new Date();
        const futureDate = new Date(today);
        futureDate.setDate(today.getDate() + 7);
        setTime(futureDate);
      } else {
        setTime(new Date(currentBranchExpiryTime));
      }
    }
  }, []);

  useEffect(() => {
    const fetchQrCode = async () => {
      if (!time && currentBranchExpiryTime && currentBranchExpiryTime >= Date.now()) {
        const qr = await getBranchQR({ qr_expiry_time: currentBranchExpiryTime });
        setDataQR(qr);
      }
    };
    fetchQrCode();
  }, [currentBranchExpiryTime]);

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal modal-blur fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" style={{ border: "1px solid var(--tblr-border-color)" }}>
            <div className="modal-header">
              <h5 className="modal-title">Tạo mã QR</h5>
              <button type="button" className="btn-close" onClick={() => setIsOpenConfirmClose(true)}></button>
            </div>
            <div className="modal-body">
              <div className="d-flex gap-3">
                <div
                  className="d-flex justify-content-center align-items-center rounded"
                  style={{ width: "50%", minHeight: "200px", backgroundColor: "var(--tblr-bg-surface-secondary, #f0f0f0)" }}
                >
                  {!Boolean(dataQR) ? (
                    <span className="fw-semibold text-center px-2">Nhấn "Tạo mã QR" để tạo mã QR</span>
                  ) : (
                    <img style={{ width: "100%" }} src={dataQR} alt="QR Code" />
                  )}
                </div>

                <div className="d-flex flex-column pt-3">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Hạn sử dụng"
                      value={time}
                      views={["year", "month", "day"]}
                      onChange={newValue => setTime(newValue)}
                      format="dd/MM/yyyy"
                    />
                  </LocalizationProvider>

                  <button
                    className="btn btn-primary mt-4"
                    onClick={handleSubmit}
                    disabled={!Boolean(time) || time.getTime() === currentBranchExpiryTime}
                  >
                    Tạo mã QR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Confirm close dialog */}
      {isOpenConfirmClose && (
        <>
          <div className="modal-backdrop fade show" style={{ zIndex: 1060 }}></div>
          <div className="modal modal-blur fade show d-block" style={{ zIndex: 1065 }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
              <div className="modal-content text-center" style={{ border: "1px solid var(--tblr-border-color)" }}>
                <div className="modal-header border-0 justify-content-center">
                  <h5 className="modal-title fw-bold">Hủy tạo mã QR</h5>
                </div>
                <div className="modal-body pt-0">
                  <p>Bạn có muốn dừng tạo mã QR?</p>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-link link-secondary me-auto" onClick={() => setIsOpenConfirmClose(false)}>
                    Huỷ
                  </button>
                  <button className="btn btn-danger" onClick={handleClose}>
                    Xác nhận
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CreateQRDialog;
